import { Component, Input, OnInit } from '@angular/core';
import { OrderModel } from 'src/app/models/order.model';
import { ProfileModel } from 'src/app/models/profile.model';
import { TourneeModel } from 'src/app/models/tournee.model';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { DataService } from 'src/app/services/data/data.service';

@Component({
  selector: 'basket-summary',
  templateUrl: './basket-summary.component.html',
  styleUrls: ['./basket-summary.component.scss'],
})
export class BasketSummaryComponent implements OnInit {

  @Input()
  mode:string // edit, view, order, catalog, sale

  @Input()
  role:string // producer, consumer

  @Input()
  order:OrderModel;

  @Input()
  user:ProfileModel;

  constructor(private dataService:DataService, public authService:AuthenticationService) 
  {
    console.log('order',this.order);
  }

  ngOnInit(){
  }

  pushAgain(tournee:TourneeModel){
    this.dataService.addOrderIntoProducer({
      consumer: this.order.consumer,
      products:tournee.products,
      finances: tournee.finances,
      status: tournee.status,
      key: this.order.key,
      details: this.order.details,
      paymentStatus:tournee.paymentStatus || this.order.paymentStatus,
    },this.order.key,tournee.producer.key,tournee.key)
  }

}
